<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Theoriepakketten</li>
            </ul>
            <h2>Theoriepakketten Theoriecoach</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="courses-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-courses-box bg-color">
                    <div class="courses-image">
                        <a (click)="goToCheckout(2, 35, '24 uur')" class="d-block image">
                            <img src="assets/img/24uur.jpg" alt="image">
                        </a>
                        <a (click)="goToCheckout(2, 35, '24 uur')" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">€35</div>
                    </div>
                    <div class="courses-content">
                        <h3><a (click)="goToCheckout(2, 35, '24 uur')">24 uur</a></h3>
                        <ul class="courses-box-footer align-items-center">
                            <li><i class='flaticon-checkmark'></i> Online videocursus</li>
                            <li><i class='flaticon-checkmark'></i> Overzicht verkeersborden</li>
                            <li><i class='flaticon-checkmark'></i> Oefenvragen per hoofdstuk</li>
                            <li><i class='flaticon-checkmark'></i> Oefen examens</li>
                            <li><i class='flaticon-checkmark'></i> Gebaseerd op het CBR theorie examen</li>
                            <li><i class='flaticon-checkmark'></i> Last minute training, verhoog je slagingskans</li>
                            <li><i class='flaticon-checkmark'></i> Meest voordelige pakket</li>
                            <li><i class='flaticon-checkmark'></i> Onbeperkt toegang</li>
                            <li>&nbsp;</li>
                        </ul>
                    </div>
                    <hr>
                    <div class="text-center">
                        <button (click)="goToCheckout(2, 35, '24 uur')" type="button" class="default-btn"><i class="flaticon-tag"></i>Direct kopen<span></span></button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-courses-box bg-color">
                    <div class="courses-image">
                        <a (click)="goToCheckout(3, 40, '1 week')" class="d-block image">
                            <img src="assets/img/1week.jpg" alt="image">
                        </a>
                        <a (click)="goToCheckout(3, 40, '1 week')" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">€40</div>
                    </div>
                    <div class="courses-content">
                        <h3><a (click)="goToCheckout(3, 40, '1 week')">1 week</a></h3>
                        <ul class="courses-box-footer align-items-center">
                            <li><i class='flaticon-checkmark'></i> Online videocursus</li>
                            <li><i class='flaticon-checkmark'></i> Overzicht verkeersborden</li>
                            <li><i class='flaticon-checkmark'></i> Oefenvragen per hoofdstuk</li>
                            <li><i class='flaticon-checkmark'></i> Oefen examens</li>
                            <li><i class='flaticon-checkmark'></i> Week lang onbeperkt oefenen</li>
                            <li><i class='flaticon-checkmark'></i> Gebaseerd op het CBR theorie examen</li>
                            <li><i class='flaticon-checkmark'></i> Meest voordelige pakket</li>
                            <li><i class='flaticon-checkmark'></i> Onbeperkt toegang</li>
                            <li>&nbsp;</li>
                            <li>&nbsp;</li>
                        </ul>
                    </div>
                    <hr>
                    <div class="text-center">
                        <button (click)="goToCheckout(3, 40, '1 week')" type="button" class="default-btn"><i class="flaticon-tag"></i>Direct kopen<span></span></button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-courses-box bg-color">
                    <div class="courses-image">
                        <a (click)="goToCheckout(4, 55, '2 weken')" class="d-block image">
                            <img src="assets/img/3weken.jpg" alt="image">
                        </a>
                        <a (click)="goToCheckout(4, 55, '2 weken')" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">€55</div>
                    </div>
                    <div class="courses-content">
                        <h3><a (click)="goToCheckout(4, 55, '2 weken')">3 weken</a></h3>
                        <ul class="courses-box-footer align-items-center">
                            <li><i class='flaticon-checkmark'></i> Online videocursus</li>
                            <li><i class='flaticon-checkmark'></i> Overzicht verkeersborden</li>
                            <li><i class='flaticon-checkmark'></i> Oefenvragen per hoofdstuk</li>
                            <li><i class='flaticon-checkmark'></i> Oefen examens</li>
                            <li><i class='flaticon-checkmark'></i> 3 weken lang onbeperkt oefenen</li>
                            <li><i class='flaticon-checkmark'></i> Gebaseerd op het CBR theorie examen</li>
                            <li><i class='flaticon-checkmark'></i> Meest voordelige pakket</li>
                            <li><i class='flaticon-checkmark'></i> Onbeperkt toegang</li>
                            <li>&nbsp;</li>
                        </ul>
                    </div>
                    <hr>
                    <div class="text-center">
                        <button (click)="goToCheckout(4, 55, '2 weken')" type="button" class="default-btn"><i class="flaticon-tag"></i>Direct kopen<span></span></button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-courses-box bg-color">
                    <div class="courses-image">
                        <a (click)="goToCheckout(5, 60, '4 weken')" class="d-block image">
                            <img src="assets/img/4weken.jpg" alt="image">
                        </a>
                        <a (click)="goToCheckout(5, 60, '4 weken')" class="fav"><i class="flaticon-heart"></i></a>
                        <div class="price shadow">€60</div>
                    </div>
                    <div class="courses-content">
                        <h3><a (click)="goToCheckout(5, 60, '4 weken')">4 weken</a></h3>
                        <ul class="courses-box-footer align-items-center">
                            <li><i class='flaticon-checkmark'></i> Online videocursus</li>
                            <li><i class='flaticon-checkmark'></i> Overzicht verkeersborden</li>
                            <li><i class='flaticon-checkmark'></i> Oefenvragen per hoofdstuk</li>
                            <li><i class='flaticon-checkmark'></i> Oefen examens</li>
                            <li><i class='flaticon-checkmark'></i> 4 weken lang onbeperkt oefenen</li>
                            <li><i class='flaticon-checkmark'></i> Gebaseerd op het CBR theorie examen</li>
                            <li><i class='flaticon-checkmark'></i> Meest voordelige pakket</li>
                            <li><i class='flaticon-checkmark'></i> Onbeperkt toegang</li>
                            <li><i class='flaticon-checkmark'></i> Meest gekozen pakket</li>

                        </ul>
                    </div>
                    <hr>
                    <div class="text-center">
                        <button (click)="goToCheckout(5, 60, '4 weken')" type="button" class="default-btn"><i class="flaticon-tag"></i>Direct kopen<span></span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
